const CourseProviderShare = () => import("./views/CourseProviderShare.vue");

export const sharedCourseRoutes = [
  {
    path: "/admin/course-shared",
    name: "AdminCourseShare",
    component: CourseProviderShare,
  },
];
